import { AppBar, Button, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router-dom-v5-compat';
import { pages } from 'common';
import HeaderMobileMenu from './HeaderMobileMenu';
import { useAppSettings, useUser } from '../../contexts';
import AccountMenu from '../AccountMenu/AccountMenu';
import Menu from '../Menu';
import { useMenuItems } from '../../hooks';
import { Logo } from '../Logo';
import PageContainer from '../PageContainer/PageContainer';

const agentMenu = [pages.agentDashboard];

/**
 * 'links' property is used when menu items don't share the same URL structure as their parent menus naming.
 * For example, '/breakeven-calculator' is a child of the 'tools' menu but the url is not '/tools/breakeven-calculator'
 * 'links' ensures the correct parent menu item is highlighted while preserving existing urls and bookmarks.
 */

const headerMenuItems = [
  {
    ...pages.lrpQuote,
    label: 'Quotes',
    links: [pages.lrpQuote.path, pages.lgmQuote.path],
  },
  {
    ...pages.coverage,
    label: 'Coverages',
    links: [pages.coverage.path, pages.watchlist.path],
  },
  {
    ...pages.breakevenCalculator,
    label: 'Tools',
    links: [
      pages.breakevenCalculator.path,
      pages.lgmQuoteScenarioAnalysis.path,
    ],
  },
  {
    ...pages.faq,
    label: 'More',
    links: [
      pages.faq.path,
      pages.contactUs.path,
      pages.apply.path,
      pages.privacyPolicy.path,
      pages.applyBusiness.path,
      pages.applyIndividual.path,
    ],
  },
];

const Header = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const { isMobile, appSettings } = useAppSettings();
  const { fullLogo, name } = appSettings;

  const headerMenu = [
    ...(user && user.isAgent ? agentMenu : []),
    ...headerMenuItems,
  ];
  const menuItems = useMenuItems(headerMenu);

  const handleSignIn = () => {
    navigate(pages.signIn.path);
  };

  return (
    <AppBar position="static" color="transparent" className="z-10">
      <PageContainer>
        <Toolbar className="flex flex-row justify-between !p-0">
          {isMobile && <HeaderMobileMenu items={menuItems} />}
          <Logo logoUrl={fullLogo} imgAlt={name} />
          {!isMobile && <Menu items={menuItems} id="main-menu" />}
          {user ? (
            <AccountMenu user={user} />
          ) : (
            <Button variant="contained" color="primary" onClick={handleSignIn}>
              Sign in
            </Button>
          )}
        </Toolbar>
      </PageContainer>
    </AppBar>
  );
};

export default Header;
